import { render, staticRenderFns } from "./oldKekefu.vue?vue&type=template&id=5ee5a082&scoped=true&"
import script from "./oldKekefu.vue?vue&type=script&lang=js&"
export * from "./oldKekefu.vue?vue&type=script&lang=js&"
import style0 from "./oldKekefu.vue?vue&type=style&index=0&id=5ee5a082&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee5a082",
  null
  
)

export default component.exports